export default __webpack_public_path__ + "static/rovo-overlay-remix2-dark-a3ddadb1dad8bdaa72725de6470f9d50.png";